import { useQuery } from 'react-query';

import {
	getDigitalCodePurposes,
	getDigitalOrdersPlatformLegend,
	getProductsAndComponents,
} from '../../services/digitalCodesService';


export const usePurposeQuery = () =>
	useQuery('getDigitalCodePurposes', () => getDigitalCodePurposes(), { staleTime: 60000 });

export const usePlatformLegendsQuery = () =>
	useQuery('getDigitalOrdersPlatformLegend', () => getDigitalOrdersPlatformLegend(), { staleTime: 60000 });

export const useProductQuery = (purposeId, platform, options) => useQuery(
	['getOrderComponents', purposeId, platform],
	() => getProductsAndComponents(purposeId, platform),
    options
);
